exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.oc-button-icon-after[data-v-70d7d89b] {margin-left:1px;}\r\n", ""]);

